/** German UI strings - align keys with `TRANSLATIONS.en` */
const de = {
  menu: {
    home: 'Start',
    ourApps: 'Unsere Apps',
    whoWeAre: 'Über uns',
    privacyPolicy: 'Datenschutz',
    contactUs: 'Kontakt',
    settings: 'Einstellungen'
  },
  siteFooter: {
    ariaLabel: 'Fußzeile',
    rightsReserved: 'Alle Rechte vorbehalten.'
  },
  home: {
    title: 'Einfache Tools. Echter Fortschritt.',
    intro:
      'Wir glauben, dass Technologie ein stiller Partner für deinen Erfolg sein sollte.',
    masterSwedishLabel: 'Schwedisch meistern:',
    masterSwedishText:
      'Über 8 Sprach-Apps, darunter TalkSvenska und SWGrammar – ein Ökosystem für Lernende und Expats.',
    simplifyFinancesLabel: 'Finanzen vereinfachen:',
    simplifyFinancesText:
      'Tools wie BillTracker und Curren$ee helfen dir, globale und lokale Ausgaben im Blick zu behalten.',
    designedLabel: 'Für alle gemacht:',
    designedText:
      'Von visuellen Timern für Kinder bis zu kniffligen Satzstellung-Rätseln – unsere Apps sind für jedes Alter und Level gedacht.',
    carouselRegion: 'Highlights der ABASHELARI-Apps',
    previousImage: 'Vorheriges Bild',
    nextImage: 'Nächstes Bild',
    howTitle: 'Das findest du in unseren Apps',
    howSubtitle:
      'Sprachenlernen, finanzielle Klarheit und familienfreundliche Tools – klar fokussiert und nützlich.',
    feature1Title: 'Schwedisch mit einem zusammenhängenden Paket',
    feature1Desc:
      'SWGrammar, TalkSvenska und die SW-Apps decken Grammatik, Wortschatz und Phrasen ab – auch offline, passend zum Alltag.',
    feature2Title: 'Geld über Grenzen hinweg im Griff',
    feature2Desc:
      'BillTracker und Curren$ee machen Abos und Ausgaben in den Währungen verständlich, die du wirklich nutzt.',
    feature3Title: 'Ruhige Tools für Kinder und den Alltag',
    feature3Desc:
      'Buchstaben-Spiele, erste Lese-Schritte und Hilfen wie Time2See – für Klarheit in jedem Alter.',
    appsStripeTitle: 'Unsere Apps',
    appsStripeAria: 'Unsere Apps - Tippe auf ein Symbol, um die Seite zu öffnen',
    appsStripePrev: 'Nach links für mehr Apps',
    appsStripeNext: 'Nach rechts für mehr Apps'
  },
  ourApps: {
    pageTitle: 'Unsere Apps',
    intro:
      'Vom Schwedischlernen und sanfter Kinder-Lektüre bis zu Alltags-Tools: Alles, was wir veröffentlichen, findest du hier. Wähle eine App für Story, Screenshots und App Store.',
    readMore: 'Mehr lesen',
    downloadLabel: 'Im App Store laden',
    appNotFound: 'App nicht gefunden.',
    screenshotsHeading: 'Screenshots & Video',
    descriptionMore: 'Mehr',
    descriptionLess: 'Weniger',
    noScreenshotsLead: 'Noch keine Screenshots. Lege 3 Bilder unter'
  },
  whoWeAre: {
    title: 'Clevere Tools für neugierige Köpfe.',
    intro:
      'ABASHELARI entwickelt fokussierte Apps: Schwedischlernen, spielerische Lektüre für Kinder und praktische Alltags-Tools. So hängt unser Arbeit zusammen.',
    section1Title: 'Schwedisch lernen',
    section1Text:
      'Die „SW“-Familie – SWGrammar, SWVerbs, SWVocabulary, SWWorder, SWAdjective und TalkSvenska – ist ein Ökosystem für Schwedischlernende: strukturierte Übung, klare Erklärungen, Audio wo es zählt und Offline-Workflows für den Alltag.',
    section2Title: 'Spiele für Kinder: Englisch & Hebräisch',
    section2Text:
      'Wir bauen ruhige, visuelle Lernspiele für erste Leser: Buchstaben nachzeichnen, Buchstaben und Wörter, Wortschatz für Englisch und Hebräisch. Bildschirmzeit mit Sinn: Wiederholung, die Kinder verstehen, gut lesbare Oberflächen und ein Tempo, das zum Lernen passt.',
    section3Title: 'Alltags-Tools',
    section3Text:
      'Neben Bildung liefern wir Hilfen für den Alltag: BillTracker für Rechnungen und Abos – auch mit mehreren Währungen. Curren$ee macht Ausgaben in den für dich wichtigen Währungen verständlich. Time2See bietet visuelle Timer für Kinder. Jedes Produkt zielt auf Schnelligkeit und Klarheit.',
    section4Title: 'Wer wir sind – und was wir wollen',
    section4Text:
      'ABASHELARI ist ein kleines, unabhängiges App-Studio. Wir setzen auf Qualität und Datenschutz statt aggressiver Monetarisierung: klare Oberflächen und Respekt vor Aufmerksamkeit und Daten. Wir bauen fokussierte Tools für echte Aufgaben – Schwedisch meistern, erste Lese-Schritte oder Haushaltsgeld lesbar machen – und verbessern sie nach echtem Nutzen.'
  },
  contact: {
    title: 'Kontakt',
    p1:
      'Frage oder Vorschlag – oder nur Hallo sagen? Wir sind ein kleines Studio und lesen jede Nachricht. Am schnellsten erreichst du uns per E-Mail:',
    p2:
      'Du kannst auch das Formular unten nutzen – wie es dir lieber ist. Wir melden uns so bald wir können.',
    p3: 'Danke, dass du dich meldest.',
    name: 'Name',
    emailLabel: 'E-Mail',
    message: 'Nachricht',
    messageErrorMin: 'Bitte mindestens 10 Zeichen in deiner Nachricht.',
    messageErrorMax: 'Maximal 500 Zeichen für deine Nachricht.',
    submitSending: 'Wird gesendet…',
    submitSuccess:
      'Danke! Deine Nachricht wurde gesendet – wir melden uns bald.',
    submitError:
      'Die Nachricht konnte nicht gesendet werden. Bitte erneut versuchen oder uns direkt mailen.',
    gotIt: 'OK',
    send: 'Nachricht senden'
  },
  settings: {
    title: 'Einstellungen',
    languageTitle: 'Sprache',
    languageDesc: 'Wähle die Sprache für die gesamte Website.',
    english: 'Englisch',
    swedish: 'Schwedisch',
    spanish: 'Spanisch',
    german: 'Deutsch',
    french: 'Französisch'
  },
  privacy: {
    title: 'Datenschutzerklärung',
    updated: 'Zuletzt aktualisiert: 3. März 2025',
    intro:
      'Diese Erklärung beschreibt, wie ABASHELARI Informationen erhebt, nutzt, speichert und schützt, wenn du unsere Website und mobilen Apps verwendest.',
    contactHeading: 'Kontakt',
    contactTextLead: 'Fragen zum Datenschutz? Schreib uns an',
    contactTextTrail: '.',
    collectHeading: 'Welche Daten wir erheben können',
    collectIntro:
      'Je nach Produkt können wir begrenzte Daten erheben, die für Betrieb, Support und Stabilität nötig sind.',
    collectItems: [
      'Kontaktdaten, die du angibst (z. B. E-Mail bei Kontaktaufnahme).',
      'Grundlegende Nutzungs- und Diagnosedaten von App oder Website (z. B. Absturzberichte oder Metriken).',
      'Technische Geräteinformationen, die Apps und Browser üblicherweise senden (Gerätetyp, OS-Version und grobe Standortableitung aus der IP, soweit relevant).'
    ],
    useHeading: 'Wie wir Informationen nutzen',
    useItems: [
      'Um unsere Apps und Website bereitzustellen, zu pflegen und zu verbessern.',
      'Um Support-Anfragen zu beantworten und wichtige Updates mitzuteilen.',
      'Um Nutzungstrends zu verstehen und Fehler zu beheben (personenbezogene Daten möglichst minimieren).'
    ],
    shareHeading: 'Weitergabe und Auftragsverarbeiter',
    shareText:
      'Wir verkaufen keine personenbezogenen Daten. Wir können Daten mit Dienstleistern teilen, die uns beim Betrieb helfen (Hosting, Analyse, E-Mail), mit angemessenen Schutzmaßnahmen und nur bei Bedarf.',
    retentionHeading: 'Speicherung',
    retentionText:
      'Wir speichern Daten nur so lange wie für die beschriebenen Zwecke nötig, sofern keine längere Aufbewahrung gesetzlich erforderlich ist.',
    securityHeading: 'Sicherheit',
    securityText:
      'Wir treffen angemessene Schutzmaßnahmen, aber keine Übertragung oder Speicherung ist zu 100 % sicher.',
    childrenHeading: 'Kinder und Datenschutz',
    childrenText:
      'Unsere Apps können für Familien geeignet sein. Wenn du glaubst, dass ein Kind ohne angemessene Einwilligung Daten angegeben hat, kontaktiere uns – wir werden angemessene Schritte zur Löschung prüfen.',
    thirdHeading: 'Links zu anderen Websites',
    thirdText:
      'Unsere Website oder Apps können auf Drittanbieter verlinken (z. B. App Store). Diese haben eigene Richtlinien.',
    changesHeading: 'Änderungen',
    changesText:
      'Wir können diese Erklärung gelegentlich aktualisieren. Dann passen wir das Datum „Zuletzt aktualisiert“ an und veröffentlichen die neue Fassung.',
    rightsHeading: 'Deine Wahlmöglichkeiten',
    rightsText:
      'Je nach Wohnsitz kannst du Rechte auf Auskunft, Berichtigung oder Löschung bestimmter Daten haben. Kontaktiere uns – wir antworten in angemessener Zeit.'
  }
};

export default de;
